import { useQuery } from "react-query";

import { autoChecklistService } from "services";

const useAlloyResultQuery = ({
	id,
	enabled = true,
}: {
	id: string;
	enabled?: boolean;
}) =>
	useQuery(["alloyResult", id], () => autoChecklistService.getAlloy(id), {
		retry: 0,
		cacheTime: 0,
		enabled: enabled && !!id,
	});

export default useAlloyResultQuery;
